export const setThemeMode = theme => {
    return {
        type: 'SET_THEME_MODE',
        payload: theme
    };
}

export const setLeftMenuWidth = width => {
    return {
        type: 'SET_LEFT_MENU_WIDTH',
        payload: width
    };
}

export const setRightMenuWidth = width => {
    return {
        type: 'SET_RIGHT_MENU_WIDTH',
        payload: width
    };
}

export const setSurveys = surveys => {
    return {
        type: 'SET_SURVEYS',
        payload: surveys
    };
}

export const setOrganizations = organizations => {
    return {
        type: 'SET_ORGANIZATIONS',
        payload: organizations
    };
}

export const setUserSurveys = userSurveys => {
    return {
        type: 'SET_USER_SURVEYS',
        payload: userSurveys
    };
}

export const setCurrentSurvey = currentSurvey => {
    return {
        type: 'SET_CURRENT_SURVEY',
        payload: currentSurvey
    };
}

export const setCurrentSurveyResult = currentSurveyResult => {
    return {
        type: 'SET_CURRENT_SURVEY_RESULT',
        payload: currentSurveyResult
    };
}

export const setBenchmarkeds = benchmarkeds => {
    return {
        type: 'SET_BENCHMARKEDS',
        payload: benchmarkeds
    };
}

export const setHomeSelectedTab = homeSelectedTab => {
    return {
        type: 'SET_HOME_SELECTED_TAB',
        payload: homeSelectedTab
    };
}

export const setSurveyDetailSelectedTab = surveyDetailSelectedTab => {
    return {
        type: 'SET_SURVEY_DETAIL_SELECTED_TAB',
        payload: surveyDetailSelectedTab
    };
}

export const setLeftMenuContent = leftMenuContent => {
    return {
        type: 'SET_LEFT_MENU_CONTENT',
        payload: leftMenuContent
    };
}

export const setSurveyRecipients = surveyRecipients => {
    return {
        type: 'SET_SURVEY_RECIPIENTS',
        payload: surveyRecipients
    };
}

export const setQuestions = questions => {
    return {
        type: 'SET_QUESTIONS',
        payload: questions
    };
}

export const setSelectedSectionAndPage = selectedSectionAndPage => {
    return {
        type: 'SET_SELECTED_SECTION_AND_PAGE',
        payload: selectedSectionAndPage
    };
}

export const setNewQuestion = newQuestion => {
    return {
        type: 'SET_NEW_QUESTION',
        payload: newQuestion
    };
}

export const setNewSurvey = newSurvey => {
    return {
        type: 'SET_NEW_SURVEY',
        payload: newSurvey
    };
}

export const setResultsCurrentQuestions = resultsCurrentQuestions => {
    return {
        type: 'SET_RESULTS_CURRENT_QUESTIONS',
        payload: resultsCurrentQuestions
    };
}
export const setLeftMenuVisibility = (visibility) => {
    return {
        type: "SET_LEFT_MENU_VISIBILITY", // Doğru action type
        payload: visibility,
    };
};

export const addTab = (id) => {
    return {
        type: "ADD_TAB", // Doğru action type
        payload: {
            id: id, label: "Home", path: "/", states: {
              benchmarkeds: [],
              currentSurvey: {},
              currentSurveyResult: [],
              currentSurveyInsightData: {},
              homeSelectedTab: "",
              leftMenuContent: "",
              leftMenuVisibility: "show",
              leftMenuExpanded: true,
              leftMenuWidth: 418,
              newQuestion: {},
              newSurvey: false,
              organizations: [],
              questions: [],
              resultsCurrentQuestions: {},
              rightMenuWidth: 350,
              selectedSectionAndPage: {},
              surveyDetailSelectedTab: "Summary",
              surveyRecipients: [],
              surveys: [],
              themeMode: "dark",
              userSurveys: [],
              newSurveyNameFromLM: "",
              pageIsLoading: false
            }
          },
    };
}

export const removeTab = (id) => {
    return {
        type: "REMOVE_TAB", // Doğru action type
        payload: id,
    };
}

export const setActiveTab = (id) => {
    return {
        type: "SET_ACTIVE_TAB", // Doğru action type
        payload: id,
    };
}

export const updateTabPath = (id, label, path) => {
    return {
        type: "UPDATE_TAB_PATH", // Doğru action type
        payload: { id, label, path }
    };
}

export const updateTabStates = (id, key, value) => {
    return {
        type: "UPDATE_TAB_STATES", // Doğru action type
        payload: { id, key, value }
    };
}
